// extracted by mini-css-extract-plugin
export default {"header":"TDS_header__zmtVe","title":"TDS_title__y7aYw","tab":"TDS_tab__F2C3-"};